export const iconFontAwesomeTextformattingCheckDouble = (
	<i className="fa-solid fa-check-double"></i>
);
